// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Select elements in the DOM
     */

    const filterTriggers = document.querySelectorAll('.js-filter');
    const filterBlogTargets = document.querySelectorAll('.blog__item');

    /**
     * Display / hide items
     */

    for (const filterTrigger of filterTriggers) {
        filterTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            const filterTriggerCategory = filterTrigger.dataset.filter;
            const filterTriggerContent = filterTrigger.dataset.filterContent;

            // Filters
            filterActive(filterTrigger);

            // Blogs
            if (filterTriggerContent == 'blog') {
                filterBlog(filterTriggerCategory);
            }

        });
    }

    /**
     * Filter
     */

    const filterActive = (item) => {
        for (const filterTrigger of filterTriggers) {
            filterTrigger.classList.remove('filter__link--active');
        }
        item.classList.add('filter__link--active');
    }

    /**
     * Blogs
     */

    const filterBlog = (category) => {
        for (const filterBlogTarget of filterBlogTargets) {
            const filterBlogTargetCategory = filterBlogTarget.dataset.filter;
            
            if (category == '*') {
                filterBlogTarget.classList.remove('blog__item--hidden');
            } else {
                if (filterBlogTargetCategory.indexOf(category) !== -1) {
                    filterBlogTarget.classList.remove('blog__item--hidden');
                } else {
                    filterBlogTarget.classList.add('blog__item--hidden');
                }
            }
        }
    }

});
